import { TG_WIDGET_BRANDING, DEFAULT_SITE_NAME } from "../config/keys";

export const getSiteName = () => {
    const branding = localStorage.getItem(TG_WIDGET_BRANDING) ? JSON.parse(localStorage.getItem(TG_WIDGET_BRANDING)) : null;

    if (!branding) {
        return DEFAULT_SITE_NAME;
    }

    const { SiteName } = branding;

    return SiteName;
}
